export default 4 / 3; //4:3